var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Subscribable, } from '@volkswagen-onehub/feature-hub-utils';
import { convertConfigurationToV2 } from './configuration-utils';
// use aliases so we only have to apply changes here
export * from './types';
export class CarConfigurationServiceV1Wrapper extends Subscribable {
    constructor(delegate) {
        super();
        this.delegate = delegate;
    }
    setDefaultContext(context, initialConfiguration, options = {}) {
        if (!initialConfiguration ||
            Object.keys(initialConfiguration).length === 0) {
            this.delegate.setDefaultContext(context, undefined);
            return;
        }
        const locked = options.lockedParameter;
        const newOptions = {};
        if (locked) {
            newOptions.lockedParameter =
                options.lockedParameter === 'tenant'
                    ? 'category'
                    : options.lockedParameter;
        }
        const configuration = convertConfigurationToV2(initialConfiguration);
        this.delegate.setDefaultContext(context, configuration, newOptions);
    }
    getContext(ctx) {
        const description = this.delegate.getContext(ctx);
        if (!description) {
            return null;
        }
        const { context, lockedParameters } = description;
        if (lockedParameters) {
            const { category: tenant } = lockedParameters, rest = __rest(lockedParameters, ["category"]);
            return {
                context,
                lockedParameters: Object.assign(Object.assign({}, rest), { tenant }),
            };
        }
        return lockedParameters;
    }
    set(configuration, context) {
        this.delegate.set(convertConfigurationToV2(configuration), context);
    }
    get(context) {
        const configuration = this.delegate.get(context);
        if (!configuration) {
            return null;
        }
        const { category: tenant } = configuration, cfg = __rest(configuration, ["category"]);
        return Object.assign({ tenant }, cfg);
    }
    async createBuildable(_context) {
        throw new Error('Not implemented in v1');
    }
    normalizeModelId(modelId) {
        return this.delegate.normalizeModelId(modelId);
    }
    subscribe(listener) {
        return this.delegate.subscribe(listener);
    }
}
